import { createResource, For, Show, type Component } from "solid-js";
import { A } from "@solidjs/router";
import { Heart } from "lucide-solid";
import { api, type Snip } from "../lib/api";
import { isLoggedIn } from "../lib/auth";
import SnipCard from "../components/SnipCard";
import Spinner from "../components/Spinner";

async function fetchLikes(): Promise<Snip[]> {
  const { data, error } = await api.GET("/me/likes", {});
  if (error) throw new Error("Beğeniler yüklenemedi");
  return data ?? [];
}

const Likes: Component = () => {
  const [snips] = createResource(() => (isLoggedIn() ? true : false), fetchLikes);

  return (
    <div class="mx-auto max-w-3xl px-4 py-6">
      <div class="mb-5 flex items-center gap-2">
        <Heart size={20} class="text-primary" />
        <h1 class="m-0 text-lg font-semibold">Beğeniler</h1>
      </div>

      <Show
        when={isLoggedIn()}
        fallback={
          <div class="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground">
            Beğendiğin gönderileri görmek için{" "}
            <A href="/sign-in" class="text-primary">giriş yap</A>.
          </div>
        }
      >
        <Show
          when={!snips.loading}
          fallback={
            <div class="flex justify-center py-16">
              <Spinner size={28} />
            </div>
          }
        >
          <Show
            when={(snips() ?? []).length > 0}
            fallback={
              <div class="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground">
                Henüz bir gönderi beğenmedin.
              </div>
            }
          >
            <div class="flex flex-col gap-3">
              <For each={snips()}>{(snip) => <SnipCard snip={snip} />}</For>
            </div>
          </Show>
        </Show>
      </Show>
    </div>
  );
};

export default Likes;
